import {Check, TimeSpan} from '@sparkware/app-utils';
import {ApplicationStartupConfigurations} from '../app-react/app-bootstrap/config-interfaces/application-startup.configurations';
import {TimeIntervalName} from '../common/utils/time-interval-names';

export const CYPRESS_TO_ORBIT_HOOKS_OBJECT_NAME = 'CypressToOrbitHooks';
export const CYPRESS_GLOBAL_OBJECT_NAME = 'Cypress';

export function isInsideAutomation(): boolean {
    return !Check.isNullOrUndefined(window[CYPRESS_GLOBAL_OBJECT_NAME])
        && !Check.isNullOrUndefined(window[CYPRESS_GLOBAL_OBJECT_NAME][CYPRESS_TO_ORBIT_HOOKS_OBJECT_NAME])
}


export function mockApplicationStartupConfigs(configs: ApplicationStartupConfigurations): ApplicationStartupConfigurations {
    if(isInsideAutomation()) {
        getCypressToOrbitHooks().onAppStartupConfigs(configs);
    }
    return configs;
}

export function getCypressToOrbitHooks(): ICypressToOrbitHooks {
    if(!isInsideAutomation()) {
        throw new Error('You can only call getCypressToOrbitHooks inside automation');
    }
    return window[CYPRESS_GLOBAL_OBJECT_NAME][CYPRESS_TO_ORBIT_HOOKS_OBJECT_NAME] as ICypressToOrbitHooks;
}

export interface OnTimeIntervalCreationResult {
    ignoreJavaScriptImplementation: boolean;
    timerId?: number;
}

export enum NamedIntervalType {
    setInterval,
    setTimeout
}

export interface ICypressToOrbitHooks {
    onAppStartupConfigs(configs: ApplicationStartupConfigurations);
    onTimeIntervalCreation(name: TimeIntervalName, callback: () => void, interval: TimeSpan, intervalType: NamedIntervalType): OnTimeIntervalCreationResult;
}

